<template>
  <div>
    <vue-select :class="size === 'normal' ? 'large-size' : 'none'" v-model="selectedCenter" :options="serviceCenters"
      :disabled="readonly" :label="$t('name')" @input="updateValue" :placeholder="$t('Seçin')">
    </vue-select>
  </div>
</template>

<script>
import { GetActiveServiceCenters } from "../../services/cls";

export default {
  props: ['value', 'readonly', 'size'],
  data() {
    return {
      serviceCenters: [],
      selectedCenter: null,
      off: this.readonly,
    }
  },
  mounted() {
    this.getActiveServiceCenters();
  },
  watch: {
    value(newValue) {
      if (newValue && this.serviceCenters.length > 0) {
        this.selectedCenter = this.serviceCenters.find(center => center.id === newValue);
      }
    },
    serviceCenters(newValue) {
      if (this.value && newValue.length > 0) {
        this.selectedCenter = newValue.find(center => center.id === this.value);
      }
    },
    readonly() {
      this.off = this.readonly;
    },
  },
  methods: {
    getActiveServiceCenters() {
      GetActiveServiceCenters().then((response) => {
        if (response.data.data) {
          this.serviceCenters = response.data.data;
        }
      });
    },
     reset() {
    this.selectedCenter = null; 
    this.$emit('input', null);
  },
    updateValue(value) {
      this.$emit('input', value.id);
    }
  }
}
</script>

<style >
.large-size .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: var(--vs-search-input-bg);
  border: var(--vs-border-width) var(--vs-border-style) var(--vs-border-color);
  border-radius: var(--vs-border-radius);
  display: -webkit-box;
  display: -ms-flexbox;
  padding: 0 0 10px;
  white-space: normal;
}

.large-size .vs__selected {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: var(--vs-border-radius);
  color: var(--font-primary) !important;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: var(--vs-line-height);
  margin: 10px 0px 0 !important;
  padding: 0 0.25em;
  z-index: 0;
  margin-left: 10px !important;
}
</style>
